import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import InfoField from "../../../../../../../ui/InfoDrawer/components/InfoField";
import DeleteConfirmationModal from "../../../../../../../ui/DeleteConfirmationModal";
import Link from "@material-ui/core/Link";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";

const mockData = [
  {
    id: 1,
    url: "www.test.ru"
  },
  {
    id: 2,
    url: "www.test2.ru"
  }
];

const useStyles = makeStyles({
  textField: {
    margin: "8px 16px"
  }
});

const DigitalMaterials = () => {
  const { textField } = useStyles();
  const [isDeleted, setIsDeleted] = React.useState(false);
  const [openDeleteMaterials, setOpenDeleteMaterials] = React.useState(false);
  const [digitalMaterials, setDigitalMaterials] = React.useState(mockData);

  const addNewField = () => {
    const values = [...digitalMaterials];
    values.push({
      id: digitalMaterials.length + 1,
      url: ""
    });
    setDigitalMaterials(values);
  };

  const change = (i, event) => {
    const values = [...digitalMaterials];
    values[i].url = event.target.value;
    setDigitalMaterials(values);
  };

  const deleteDigitalMaterials = id => {
    const newState = digitalMaterials.filter(item => item.id !== id);
    setDigitalMaterials(newState);
  };

  return (
    <>
      <Grid container alignItems="baseline">
        <Grid item>
          <InfoField name="Цифровые учебные материалы" />
        </Grid>
        <Grid item>
          <Link
            variant="caption"
            onClick={() => addNewField()}
            style={{ color: "#007FBD", cursor: "pointer" }}
          >
            Добавить
          </Link>
        </Grid>
        <DeleteConfirmationModal
          open={openDeleteMaterials}
          handleClose={() => setOpenDeleteMaterials(false)}
          modalText="Удалить цифровой материал"
          additionalText={isDeleted && isDeleted.url}
          onConfirm={() =>
            deleteDigitalMaterials(isDeleted.id) ||
            setOpenDeleteMaterials(false)
          }
        />
      </Grid>
      <>
        {digitalMaterials.map((item, idx) => (
          <FormControl key={`List-${idx}`} fullWidth>
            <Input
              value={item.url}
              onChange={event => change(idx, event)}
              className={textField}
              endAdornment={
                <InputAdornment position="end">
                  <Tooltip title="Удалить" placement="top-start">
                    <IconButton
                      onClick={() =>
                        setIsDeleted(item) || setOpenDeleteMaterials(true)
                      }
                    >
                      <DeleteForeverOutlinedIcon
                        fontSize="small"
                        style={{ color: "#93A7BE" }}
                      />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              }
            />
          </FormControl>
        ))}
      </>
    </>
  );
};

export default DigitalMaterials;
